module.exports = __webpack_public_path__ + "images/other.28225643352df82383a61313ae670f24.svg";